import React from 'react';
import ReportViewer from '../../components/reports/ReportViewer';

// 🟢 Comprehensive mock data with categories, groups, and dates
const mockData = [
  // INCOME
  { date: '2025-05-01', income: 4500, expenses: 0, category: 'Paychecks', group: 'Income', category_group: 'Income' },
  { date: '2025-05-02', income: 200, expenses: 0, category: 'Interest', group: 'Income', category_group: 'Income' },
  { date: '2025-05-03', income: 400, expenses: 0, category: 'Business Income', group: 'Income', category_group: 'Income' },

  // EXPENSES
  { date: '2025-05-01', income: 0, expenses: 1200, category: 'Cash & ATM', group: 'Financial', category_group: 'Expenses' },
  { date: '2025-05-01', income: 0, expenses: 350, category: 'Groceries', group: 'Food & Dining', category_group: 'Expenses' },
  { date: '2025-05-02', income: 0, expenses: 200, category: 'Restaurants & Bars', group: 'Food & Dining', category_group: 'Expenses' },
  { date: '2025-05-02', income: 0, expenses: 250, category: 'Gas', group: 'Auto & Transport', category_group: 'Expenses' },
  { date: '2025-05-03', income: 0, expenses: 450, category: 'Financial Fees', group: 'Financial', category_group: 'Expenses' },
  { date: '2025-05-03', income: 0, expenses: 100, category: 'Internet & Cable', group: 'Bills & Utilities', category_group: 'Expenses' },
  { date: '2025-05-04', income: 0, expenses: 1600, category: 'Rent', group: 'Housing', category_group: 'Expenses' },
  { date: '2025-05-04', income: 0, expenses: 95, category: 'Phone', group: 'Bills & Utilities', category_group: 'Expenses' },
  { date: '2025-05-04', income: 0, expenses: 130, category: 'Insurance', group: 'Financial', category_group: 'Expenses' },
  { date: '2025-05-05', income: 0, expenses: 60, category: 'Coffee Shops', group: 'Food & Dining', category_group: 'Expenses' },
  { date: '2025-05-05', income: 0, expenses: 300, category: 'Public Transit', group: 'Auto & Transport', category_group: 'Expenses' },
  { date: '2025-05-06', income: 0, expenses: 80, category: 'Charity', group: 'Gifts & Donations', category_group: 'Expenses' },
  { date: '2025-05-06', income: 0, expenses: 150, category: 'Petrol', group: 'Auto & Transport', category_group: 'Expenses' },
  { date: '2025-05-07', income: 0, expenses: 230, category: 'Taxi & Ride Shares', group: 'Auto & Transport', category_group: 'Expenses' },
  { date: '2025-05-07', income: 0, expenses: 99, category: 'Parking & Tolls', group: 'Auto & Transport', category_group: 'Expenses' },
  // You can add more!
];

const Reports: React.FC = () => {
  // No date filtering here; all data passed to ReportViewer, which handles its own filters
  return (
    <div>
      <ReportViewer
        config={{
          chartType: 'sankey', // Try 'sankey', 'bar', 'table', etc.
          metrics: ['income', 'expenses']
        }}
        data={mockData}
      />
    </div>
  );
};

export default Reports;
